import { render, staticRenderFns } from "./LocumSuccessBookingConfirmed.vue?vue&type=template&id=374029eb&"
import script from "./LocumSuccessBookingConfirmed.vue?vue&type=script&lang=js&"
export * from "./LocumSuccessBookingConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports